<template>
  <div class="footer">
    <div class="footer_top">
      <div>
        <div class="footer_content">
          <div class="footer_content-top">
            <div class="footer_content-top-left">友情链接:</div>
            <div class="ol_lists">
              <ul>
                <li v-for="(item,index) in list" :key="index"><a :href="'http://'+item.link"  target="_blank">{{item.linkName}}</a><span v-if="index!=list.length-1">|</span></li>
              </ul>
            </div>
          </div>
          <div class="footer_content-bottom">
            <div class="footer_content-bottom-left">
              <img src="../assets/images/organ.png" alt="">
              <ul>
                <!-- <li>Copyright © 2018 厦门i健身　 版权所有</li>
                <li>主办单位：厦门市体育局　 技术支持：厦门市信息中心　 地址：厦门市体育路2号</li>
                <li>办公室：0592-5121239　 值班室：0592-5127451　　 传真：0592-5121234</li> -->
                <li>
                  <p>主办单位：厦门市体育局</p>
                  <p>技术支持：厦门市信息中心</p>
                  <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：厦门市体育路2号</p>
                </li>
                <li>
                  <p>办公室：0592-5121239</p>
                  <p>值班室：0592-5127451</p>
                  <p>传&nbsp;&nbsp;&nbsp;&nbsp;真：0592-5121234</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer_content-bottom-right">
          <img src="../assets/images/wx_qrcode.jpg" alt="">
          <span>厦门i健身公众号</span>
        </div>
      </div>
    </div>
    <div class="footer_bot">
      Copyright ©2023 厦门i健身&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有
    </div>
  </div>
</template>

<script>
import {getFriendlyLink} from '@/api/home/index.js'
    export default {
        name: "footerComponent",
        data(){
          return{
            list:[],
          }
        },
        methods:{
          async setData(){
            let res=await getFriendlyLink()
            // this.list = res.result
            this.list = res.result.records
            // this.$axios.post('friendlyLink/all').then(res=>{
            //   if(res.data.code == 200 &&res.data.result){
            //     this.list = res.data.result
            //   }
            //   // console.log(this.list)s
            // })
          }
        },
        created(){
          this.setData()
        }
    }
</script>

<style scoped lang="less">
  .footer{
    width:100%;
    &_top{
      background-image: url('../assets/images/new_image/foot.png');
      background-size: 100% 200px;
      background-repeat: no-repeat;
      >div{
        width: 959px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        .footer_content{
          height: 100%;
          .footer_content-top{
            display: flex;
            .footer_content-top-left{
              height: 100%;
              padding-top: 32px;
              font-size: 14px;
              box-sizing: border-box;
              color: #fff;
            }
            .ol_lists{
              flex: 1;
              height: 100%;
              ul{
                float: left;
                width: 100%;
                height: 100%;
                margin: 0;
                padding: 0;
                list-style: none;
                li{
                  display: inline-block;
                  
                  margin-top: 31px;
                  text-overflow: ellipsis;
                  white-space:nowrap;
                  overflow:hidden;
                  color:#fff;
                  a{
                    padding: 0 20px;
                    font-size: 14px;
                    color:#fff;
                  }
                  a:hover{
                    color: blue;
                  }
                }
              }
            }
          }
          .footer_content-bottom{
            width: 100%;
            display: flex;
            .footer_content-bottom-left{
              display: flex;
              overflow: hidden;
              img{
                margin-top: 31px;
                width: 60px;
                height: 74px;
              }
              ul{
                display: flex;
                vertical-align: top;
                margin:31px;
                padding: 0;
                list-style: none;
                li{
                  font-size: 14px;
                  color: #fff;
                  padding-right: 80px;
                  p{
                    margin-bottom: 8px;
                  }
                }

                li:nth-of-type(1){
                  border-right: 1px solid #fff;
                }

                li:nth-of-type(2){
                  padding-left: 80px;
                }
              }
            }
          }
        }
        .footer_content-bottom-right{
          text-align: center;
          margin: 31px 0 0 0;
          img{
            display: block;
            width: 122px;
            height: 122px;
          }
          span{
            margin-top: 12px;
            color: #fff;
            font-size: 12px
          }
        }
      }
    }
    &_bot{
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      color: #fff;
      width: 100%;
      background:#282828;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footerComponent.vue